import React from 'react';
import { PostItemFragment, PostMultiMediaAttachMode } from '../../../../models/graphql';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import classes from './PostPreviewModal.module.scss';
import { EditorText, MediaTypePostEditorState } from '../../../../models/post-editor';
import { mapProfileFragmentToSelectedSocialProfileValue } from '../../../PostEditor/helpers/mapProfileFragmentToSelectedSocialProfileValue';
import updateImmutable from 'immutability-helper';
import { mapPostTikTokToTikTokProfileValues } from '../../../PostEditor/helpers/mapSelectedProfilesValues';
import { usePostEditorPostFetch } from '../../../../hooks/usePostEditorPostFetch';
import { PostCardMediaPreviewWrapper } from '../../../PostEditor/PostPreview/PostCardMediaPreviewWrapper';
import { Loader } from '../../../../components/containers/Loader';

export type PostPreviewModalViewProps = {
  //
  post: PostItemFragment;
  editPost: (post: PostItemFragment) => void;
  onClose: VoidFunction;
};

export const PostPreviewModalView = (props: PostPreviewModalViewProps): JSX.Element => {
  const { post, editPost, onClose } = props;
  const postProfile = post.socialProfile;
  let selectedProfile = mapProfileFragmentToSelectedSocialProfileValue([postProfile])[0]; //stateProfiles
  if (selectedProfile.__typename === 'PinterestSocialProfile') {
    selectedProfile = updateImmutable(selectedProfile, {
      pnBoardId: { $set: post.pinterestBoardId || undefined }
    });
  }
  if (selectedProfile.__typename === 'TikTokSocialProfile') {
    selectedProfile = updateImmutable(selectedProfile, {
      tikTok: { $set: post.tikTok ? mapPostTikTokToTikTokProfileValues(post.tikTok) : undefined }
    });
  }

  const { loading, profiles, initialState, error } = usePostEditorPostFetch(post.id, 'preview');
  const initialPostEditorPost = initialState.postGroups[0].posts.length
    ? initialState.postGroups[0].posts[0]
    : initialState.postGroups[0].groupPostAttributes;
  const textVariationIndex = initialPostEditorPost.content.variationMeta.textVariationIndex;
  const mediaVariationIndex = initialPostEditorPost.content.variationMeta.mediaVariationIndex;

  const postEditorPost = updateImmutable(initialPostEditorPost, {
    content: {
      texts: {
        $apply: (current: EditorText[]) =>
          typeof textVariationIndex === 'number' ? [current[textVariationIndex - 1]] : [current[0]]
      },
      media: {
        $apply: (current: MediaTypePostEditorState[]) =>
          typeof mediaVariationIndex === 'number' &&
          initialPostEditorPost.content.varyMedia === PostMultiMediaAttachMode.ALTERNATE
            ? [current[mediaVariationIndex - 1]]
            : current
      }
    }
  });

  return (
    <Modal
      contentClass={classes.PostPreviewModalScrollerBg}
      onClose={onClose}
      size={'large'}
      title={'Preview Post'}
      primaryButtonColor={ButtonColorsEnum.primary}
      primaryButtonTitle={'Edit Post'}
      primaryButtonLoading={loading}
      primaryButtonType={'button'}
      primaryButtonAction={() => {
        editPost(post);
      }}>
      <div className={classes.PostPreviewModal}>
        {!loading && !error ? (
          <PostCardMediaPreviewWrapper
            context={'queue'}
            post={postEditorPost}
            profiles={profiles}
            stateProfiles={[selectedProfile]}
          />
        ) : (
          <Loader variation={'dark'} size={'medium'} type={'overlay'} containedOverlay={true} roundedBg={true} />
        )}
      </div>
    </Modal>
  );
};
